module.exports = __webpack_public_path__ + "img/entwined@2x.2579931.webp";